// This file is auto-generated. Do not edit manually.
// Used by GamePlayAgain.jsx to provide meme filenames for win/draw outcomes.
//https://tenor.com/
export const winMemes = [
  "win1.jpg",
  "win2.jpg",
  "win3.jpg",
  "win4.jpg",
  "win5.jpg",
  "win6.jpg",
  "win7.jpg",
  "win8.jpg",
  "win9.gif",
   "win10.gif",
    "win11.gif",
    "win12.gif",
    "win13.gif",
    "win14.gif",
    "win15.gif",
    "win16.gif",
    "win17.gif",
    "win18.gif",
    "win19.gif",
    "win20.gif",
    "win21.gif",
    "win22.gif",
    "win23.gif",
    "win24.gif",
    "win25.gif",
    "win26.gif",
    "win27.gif"


];

export const drawMemes = [
  "draw1.jpg",
  "draw2.jpg",
  "draw3.jpg",
  "draw4.gif",
  "draw5.gif",
  "draw6.gif",
  "draw7.gif"
];
